import { DeviceConfigId, ServiceMessageSetId, VoiceSetId } from 'shared/models';
import { s3Bucket } from "./env";

export function getVoiceSetMediaUrl(voiceSetId: VoiceSetId, filename: string) {
    if (!s3Bucket) {
        // Fallback for Storybook
        return filename;
    }
    return `https://${s3Bucket}.s3.amazonaws.com/voice-sets/${voiceSetId}/${filename.replace(/\+/g, '%2B')}`;
}

export function getServiceMessageMediaUrl(serviceMessageSetId: ServiceMessageSetId, filename: string) {
    if (!s3Bucket) {
        // Fallback for Storybook
        return filename;
    }
    return `https://${s3Bucket}.s3.amazonaws.com/service-message-sets/${serviceMessageSetId}/${filename.replace(/\+/g, '%2B')}`;
}

export function getOverrideServiceMessageMediaUrl(deviceConfigId: DeviceConfigId, filename: string) {
    if (!s3Bucket) {
        // Fallback for Storybook
        return filename;
    }
    return `https://${s3Bucket}.s3.amazonaws.com/device-configs/${deviceConfigId}/overrides/${filename.replace(/\+/g, '%2B')}`;
}
